import React, { PureComponent } from 'react';
import cls from 'classnames';

import { l10n } from '@ott/l10n';

import Travellers, { TravellersItem } from '@ott/travellers';
import PlusMinus from '@ott/plus-minus';

import TravellersChildren from './blocks/TravellersChildren';

import s from './TravellersWithClasses.scss';

class TravellersWithClassesWrapper extends PureComponent {
  constructor(props) {
    super(props);

    const { isMobile, isComplex, adultsCount, childrenAges } = props;

    this.plusMinusClassNames = {
      quantity: s['travellers-count'],
    };

    this.travellersClassNames = {
      root: cls(s.Travellers, isComplex && s['Travellers--complexRoute']),
      input: cls(s.inputTrigger, isComplex && s['inputTrigger--complexRoute']),
      container: cls(
        s.container,
        isMobile && s['container--isMobile'],
        !isComplex && s['container--isSimple']
      ),
    };

    this.handleFocus = this.handleFocus.bind(this, { adultsCount, childrenAges });
    this.handleBlur = this.handleBlur.bind(this, { adultsCount, childrenAges });
  }

  handleFocus = (fields, event) => {
    ['adultsCount', 'childrenAges'].forEach((entity) => {
      const field = fields[entity];
      if (field && field.input) {
        field.input.onFocus(event);
      }
    });
  };

  handleBlur = (fields, event) => {
    ['adultsCount', 'childrenAges'].forEach((entity) => {
      const field = fields[entity];
      if (field && field.input) {
        field.input.onBlur(event);
      }
    });
  };

  getTriggerValue() {
    const {
      adultsCount: { input: adultsInput = {} },
      childrenAges: { input: childrenInput = {} },
      selectedClass,
    } = this.props;

    return l10n('travellersControl.labelWithClasses', {
      passCount: (adultsInput.value || 0) + (childrenInput.value || []).length,
      flyServiceClass: l10n(`flight.service.${selectedClass}`).toLowerCase(),
    });
  }

  renderTravellersItem = (adults, childrenAges) => {
    const { minAdults, maxAdults, maxChildren, childrenAgeRange } = this.props;

    const value = adults.input.value;

    const adultsNode = (
      <PlusMinus
        childrenClassNames={this.plusMinusClassNames}
        min={minAdults}
        max={maxAdults}
        value={value}
        label={`${value} ${l10n('adults', { value })}`}
        onChange={adults.input.onChange}
      />
    );
    const childrenNode = (
      <TravellersChildren
        maxChildren={maxChildren}
        childrenAgeRange={childrenAgeRange}
        childrenAges={childrenAges.input.value}
        onChildrenAgesChange={childrenAges.input.onChange}
      />
    );

    return <TravellersItem adultsNode={adultsNode} childrenNode={childrenNode} />;
  };

  render() {
    const {
      adultsCount: adultsField,
      childrenAges: childrenField,
      onAdultsChange,
      onChildrenChange,
      footer,
      deviceInfo,
    } = this.props;

    adultsField.input.onChange = onAdultsChange;
    childrenField.input.onChange = onChildrenChange;

    const triggerValue = this.getTriggerValue();
    const isInvalid =
      adultsField.meta.submitFailed && (childrenField.meta.invalid || adultsField.meta.invalid);

    return (
      <Travellers
        childrenClassNames={this.travellersClassNames}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        isInvalid={isInvalid}
        triggerValue={triggerValue}
        travellersList={this.renderTravellersItem(adultsField, childrenField)}
        usePortalOverlay={true}
        footer={footer}
        hasDoneButton={deviceInfo.isMobile}
        withArrowIcon={true}
        deviceInfo={deviceInfo}
      />
    );
  }
}

export default TravellersWithClassesWrapper;
